import { ErrorBoundary } from 'react-error-boundary'
import type { ReactNode } from 'react'
import { ErrorFallback } from './ErrorFallback'
import { captureException } from '@utils/sentry'

interface AppErrorBoundaryProps {
  children: ReactNode
  onReset?: () => void
}

export const AppErrorBoundary = ({ children, onReset }: AppErrorBoundaryProps) => (
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onError={(error, info) => captureException(error, { componentStack: info.componentStack })}
    onReset={onReset}
  >
    {children}
  </ErrorBoundary>
)
